import { gql } from '@apollo/client';

export const ACCOUNTING_EXPORTS = gql`
    query AccountingExports($first: Int, $after: String) {
        accountingExports(first: $first, after: $after) {
            edges {
                node {
                    id
                    exportType
                    startDate
                    endDate
                    statusFilter
                    typeFilter
                    provider
                    recordCount
                    fileUrl
                    createdBy {
                        id
                        firstName
                        lastName
                    }
                    createdAt
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
            totalCount
        }
    }
`;
